import {
  DiscountsList,
  ProductsQueryHeader,
  ProductsQueryProvider,
} from '@airship-platform/airship-proposal';
import { FlexBox } from '@airship-platform/jam-web/components';
import React from 'react';
import AddDiscountButton from './AddDiscountButton';
import EquipmentList from './EquipmentList';

const ProductsQueryView: React.FC = () => (
  <ProductsQueryProvider>
    <FlexBox flexDirection={'column'} gap={3}>
      <ProductsQueryHeader />

      <DiscountsList>
        {(discount) => <AddDiscountButton discount={discount} />}
      </DiscountsList>

      <EquipmentList />
    </FlexBox>
  </ProductsQueryProvider>
);

export default ProductsQueryView;
